/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';

import DeleteButton from '../../../elements/DeleteButton';
import EditButton from '../../../elements/EditButton';
import Search from '../../../elements/Search';
import ViewButton from '../../../elements/ViewButton';
import Paginator from '../../../elements/paginator';
import { TimeHelper } from '../../../helpers/TimeHelper';
import axios from '../../../services/MyAxios';
import { CasinoDepositBonus } from '../../Models/CasinoDepositBonus';
import { API_CASINO_DEPOSIT_BONUSES, API_CASINO_DEPOSIT_BONUSES_DELETE } from '../Helpers/CrmApiUrls';
import { CRM_PERMISSION } from '../Helpers/CrmPermissions';
import { CASINO_DEPOSIT_BONUS_CREATE, CASINO_DEPOSIT_BONUS_SHOW, CASINO_DEPOSIT_BONUSES } from '../Helpers/CrmUrls';

import { replaceUrlParams } from '../Helpers/UrlHelper';

import ActionButton from 'crm/elements/ActionButton';

function DepositBonusList() {
    const [depositBonuses, setDepositBonuses] = useState<CasinoDepositBonus[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [lastPage, setLastPage] = useState<number>(1);
    const [filter, setFilter] = useState<string>('');

    const getDepositBonuses = (page: number = 1) => {
        let url = API_CASINO_DEPOSIT_BONUSES;
        if (page !== 1) {
            url += `?page=${page}`;
        }
        axios.get(url, { params: { filter } }).then((response) => {
            setDepositBonuses(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
        });
    };

    useEffect(() => {
        getDepositBonuses(currentPage);
    }, []);

    useEffect(() => {
        getDepositBonuses(currentPage);
    }, [filter]);

    const filterTable = (value: string) => {
        setFilter(value);
    };

    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex justify-content-between">
                    <div>
                        <ActionButton
                            url={CASINO_DEPOSIT_BONUS_CREATE}
                            title="Create a new deposit bonus"
                            permissions={[CRM_PERMISSION.CREATE_DEPOSIT_BONUS_PAGE]}
                        />
                    </div>
                    <Search additionalClasses="float-right" filterTable={filterTable} />
                </div>
                {depositBonuses.length > 0 ? (
                    <div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Currency</th>
                                    <th>Deposit range</th>
                                    <th>Actions</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {depositBonuses.map((depositBonus) => (
                                    <tr key={depositBonus.id}>
                                        <td>{depositBonus.id}</td>
                                        <td>{depositBonus.name}</td>
                                        <td>{depositBonus.currency_code}</td>
                                        <td>
                                            {`Min: ${depositBonus.min_deposit} ${depositBonus.currency_code}`}
                                            <br />
                                            {`Max: ${depositBonus.max_deposit} ${depositBonus.currency_code}`}
                                        </td>
                                        <td>
                                            <ViewButton
                                                url={replaceUrlParams(CASINO_DEPOSIT_BONUS_SHOW, {
                                                    id: depositBonus.id,
                                                })}
                                                permissions={[CRM_PERMISSION.DEPOSIT_BONUS_SHOW]}
                                                key="view"
                                                title="show"
                                            />
                                            <EditButton
                                                url={`${CASINO_DEPOSIT_BONUSES}/${depositBonus.id}/edit`}
                                                permissions={[CRM_PERMISSION.DEPOSIT_BONUS_EDIT]}
                                                key="edit"
                                                title="edit"
                                            />
                                            {TimeHelper.isFuture(depositBonus.available_from) ? (
                                                <DeleteButton
                                                    url={replaceUrlParams(API_CASINO_DEPOSIT_BONUSES_DELETE, {
                                                        id: depositBonus.id,
                                                    })}
                                                    permissions={[CRM_PERMISSION.DEPOSIT_BONUS_DELETE]}
                                                    key="delete"
                                                    action={getDepositBonuses}
                                                />
                                            ) : (
                                                <div />
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getDepositBonuses} />
                    </div>
                ) : (
                    <p>Cannot find any deposit bonus.</p>
                )}
            </div>
        </div>
    );
}

export default DepositBonusList;
